<!-- An input allowing the user to enter a filepath (or multiple filepaths) -->
<template>
    <div class="q-gutter-y-sm">
        <div v-for="(filepath, idx) in model" :key="idx" class="row">
            <div class="col">
                <form-input
                    v-model="model[idx]"
                    :placeholder="$t('file_link_placeholder')"
                    :disable="disable"
                >
                    <template v-if="multiple" #prepend>
                        <q-badge color="input" text-color="input">
                            {{ $t('link') }} #{{ idx + 1 }}
                        </q-badge>
                    </template>
                </form-input>
            </div>

            <appends-button v-if="idx === 0" icon="help_outline">
                <q-tooltip>
                    {{ $t('files_no_longer_uploaded_tooltip') }}
                </q-tooltip>
            </appends-button>

            <copy-to-clipboard-button v-if="filepath" :copy-fn="() => filepath" />

            <appends-button
                v-if="!disable && filepath"
                color="negative"
                text-color="white"
                icon="clear"
                @click="removeFilepath(filepath, idx)"
            />
        </div>

        <add-button v-if="multiple" secondary @click="addFilepath" />
    </div>
</template>

<script setup>
import AppendsButton from 'src/components/buttons/AppendsButton.vue'
import CopyToClipboardButton from 'src/components/buttons/CopyToClipboardButton.vue'
import { confirmDelete } from 'src/utils/dialogs.js'
import { onMounted, watch } from 'vue'

const model = defineModel(Array) // An array of strings

const props = defineProps({
    disable: Boolean,
    multiple: Boolean,
    noConfirm: Boolean, // Skip confirmation when deleting?
})

const emit = defineEmits(['change'])

function addFilepath() {
    if (model.value) model.value.push('')
    else model.value = ['']
}

async function removeFilepath(filepath, idx) {
    if (filepath && !props.noConfirm) await confirmDelete(trans('file_link'))

    // Dont remove the last remaining input
    if (model.value.length === 1) {
        model.value[0] = ''
    } else {
        model.value.splice(idx, 1)
    }
}

// Add a placeholder entry if no existing data available
if (!model.value) addFilepath()

onMounted(() => {
    watch(model, () => emit('change', model.value), { deep: true })
})
</script>
